import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vulncheck = defineConnector({
  identifier: "vulncheck",
  name: "VulnCheck",
  tagLine: "Vulnerability intelligence",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.vulncheck\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a token",
      items: [
        {
          kind: "markdown",
          content:
            "Go to your [VulnCheck tokens page](https://vulncheck.com/settings/tokens), click **Create Token**, and enter a label.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.vulncheck.com/v3/index",
  },
});
